import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
export function LoginPage() {
  useEffect(() => {
    window.location.href = 'https://app.meetsynthia.ai';
  }, []);
  return null;
}